<template>
<div class="page-wrapper">
	<div class="page page-changelog">
		<div class="container">
			<!-- <div class="page-header">
				<h1 class="page-title">Changelog</h1>
			</div> -->
			<div class="page-content">
				<div class="card card-shadow markdown">
					<changelog-markdown class="markdown-body"></changelog-markdown>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ChangelogMarkdown from '../components/ChangelogMarkdown.vue';

export default {
	name: 'changelog',
	components: {
		ChangelogMarkdown,
	},
	data() {
		return {
		};
	},
	methods: {
		...mapActions({
		}),
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	created() {
		document.body.classList.add('is-blue');
	},
	destroyed() {
		document.body.classList.remove('is-blue');
	},
};
</script>
